import { NAME } from './constants';

export const DOWNLOAD_PROPOSAL_PDF = `${NAME}/DONWLOAD_OFFER_PDF`;
export const DOWNLOAD_PROPOSAL_PDF_SUCCESS = `${NAME}/DONWLOAD_OFFER_PDF_SUCCESS`;
export const DOWNLOAD_PROPOSAL_PDF_FAILURE = `${NAME}/DONWLOAD_OFFER_PDF_FAILURE`;

export const DOWNLOAD_OFFER_XLS = `${NAME}/DOWNLOAD_OFFER_XLS`;
export const DOWNLOAD_OFFER_XLS_FAILURE = `${NAME}/DOWNLOAD_OFFER_XLS_FAILURE`;
export const DOWNLOAD_OFFER_XLS_SUCCESS = `${NAME}/DOWNLOAD_OFFER_XLS_SUCCESS`;

export const FETCH_PROPOSAL_CONTENT = `${NAME}/FETCH_PROPOSAL_CONTENT`;
export const FETCH_PROPOSAL_CONTENT_FAILURE = `${NAME}/FETCH_PROPOSAL_CONTENT_FAILURE`;
export const FETCH_PROPOSAL_CONTENT_SUCCESS = `${NAME}/FETCH_PROPOSAL_CONTENT_SUCCESS`;

export const FETCH_PROPOSAL_DETAILS = `${NAME}/FETCH_PROPOSAL_DETAILS`;
export const FETCH_PROPOSAL_DETAILS_FAILURE = `${NAME}/FETCH_PROPOSAL_DETAILS_FAILURE`;
export const FETCH_PROPOSAL_DETAILS_SUCCESS = `${NAME}/FETCH_PROPOSAL_DETAILS_SUCCESS`;

export const FETCH_PV_LAYOUT = `${NAME}/FETCH_PV_LAYOUT`;
export const FETCH_PV_LAYOUT_FAILURE = `${NAME}/FETCH_PV_LAYOUT_FAILURE`;
export const FETCH_PV_LAYOUT_SUCCESS = `${NAME}/FETCH_PV_LAYOUT_SUCCESS`;

export const UPDATE_TEMPLATE = `${NAME}/UPDATE_TEMPLATE`;
export const UPDATE_TEMPLATE_FAILURE = `${NAME}/UPDATE_TEMPLATE_FAILURE`;
export const UPDATE_TEMPLATE_SUCCESS = `${NAME}/UPDATE_TEMPLATE_SUCCESS`;

export const RESET = `${NAME}/RESET`;

export const SET_INITIALIZE = `${NAME}/SET_INITIALIZE`;

export const SET_IS_DOWNLOADING = `${NAME}/SET_IS_DOWNLOADING`;

export const SET_SELECTED_DOCUMENT = `${NAME}/SET_SELECTED_DOCUMENT`;
